import { render, staticRenderFns } from "./courseChapterDialog.vue?vue&type=template&id=5dfd4f13&scoped=true&"
import script from "./courseChapterDialog.vue?vue&type=script&lang=js&"
export * from "./courseChapterDialog.vue?vue&type=script&lang=js&"
import style0 from "./courseChapterDialog.vue?vue&type=style&index=0&id=5dfd4f13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd4f13",
  null
  
)

export default component.exports